//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import {
  IPartialState,
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasFeature,
  hasSomeFeatures,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

function CommerceStateFactory(state: IPartialState) {
  const data = {
    title: 'Commerce',
    navGroup: NavGroup.COMMERCE,
    ...state.data,
  };

  return StateFactory({
    ...state,
    data,
  });
}

export function routingRules() {
  // No routing rules
}

export const states = {
  showroom: CommerceStateFactory({
    url: '/showroom',
    template: componentNameToTemplate('SocialPage'),
    data: {
      title: 'Showroom',
      hasAccess: () => hasFeature(FeatureNames.TributarySelfServe),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.commerce',
        () => import('@commerce/CommerceApp'),
      ),
    },
  }),
  reveal: CommerceStateFactory({
    url: '/reveal',
    template: componentNameToTemplate('RevealPage'),
    data: {
      title: 'Reveal',
      hasAccess: () => hasFeature(FeatureNames.RevealPage),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.commerce',
        () => import('@commerce/CommerceApp'),
      ),
    },
  }),
  'email-storefronts': CommerceStateFactory({
    url: '/email-storefronts',
    template: componentNameToTemplate('EmailStorefrontsPage'),
    data: {
      title: 'Email Storefronts',
      hasAccess: () => hasFeature(FeatureNames.EmailBuilder),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.commerce',
        () => import('@commerce/CommerceApp'),
      ),
    },
  }),
  'ad-permissions': CommerceStateFactory({
    url: '/ad-permissions',
    template: componentNameToTemplate('MetaAdsPage'),
    data: {
      title: 'Instagram: Ad Permissions',
      hasAccess: () => hasFeature(FeatureNames.InstagramAdsContentAllowlisting),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.commerce',
        () => import('@commerce/CommerceApp'),
      ),
    },
    redirectTo: 'meta-ads',
  }),
  'meta-ads': CommerceStateFactory({
    url: '/meta-ads',
    template: componentNameToTemplate('MetaAdsPage'),
    data: {
      title: 'Meta Ads',
      hasAccess: () =>
        hasSomeFeatures(FeatureNames.InstagramAdsContentAllowlisting),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.commerce',
        () => import('@commerce/CommerceApp'),
      ),
    },
  }),
  'spark-ads': CommerceStateFactory({
    url: '/spark-ads',
    template: componentNameToTemplate('SparkAdsPage'),
    data: {
      title: 'TikTok: Spark Ads',
      hasAccess: () => hasFeature(FeatureNames.TiktokSparkAds),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.commerce',
        () => import('@commerce/CommerceApp'),
      ),
    },
  }),
};
